export const DROPDOWN_MASTER_CHECKBOX_INDEX = 0;
export const MAX_INPUT_LENGTH = 23;
export const MAX_SHORTENED_VALUE_LENGTH = 20;
export const MULTIPLE_OPTION_SEPARATOR = ', ';
export const SHORTENED_VALUE_START_INDEX = 0;
export const SHORTENED_VALUE_SUFFIX = '...';
export const SCROLLABLE_MIN_OPTIONS = 5;
